import { initWith } from '@yola/checkoutservice-client-js';

/** @typedef {import('@yola/checkoutservice-client-js').CheckoutServiceClient} CheckoutServiceClient */

/** @type {CheckoutServiceClient | null} */
let client = null;

/** @param {string} apiUrl */
const init = (apiUrl) => {
  client = initWith({ baseUrl: apiUrl });
};

/** @returns {CheckoutServiceClient} */
const get = () => {
  if (!client) {
    throw new Error('CheckoutServiceClient is not initialized.');
  }

  return client;
};

export default { init, get };
